<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX18xKQdoKENCVg/OYI4FqayWfnDg747TEdE=","cpf":"U2FsdGVkX1+kJbffxK7BrAwAvBTMUbtIlR9U7O1NDo4="},{"num_cand":"U2FsdGVkX1+Lqafkxa/QDkGlk71EcoqNnt3w04QTt28=","cpf":"U2FsdGVkX1+dBEBk0HmRj60AABrMTlz7KT1MLbXhd1o="},{"num_cand":"U2FsdGVkX1+a3+aqF/6pTAfoBuLCzW0eFvLt4vAMWL0=","cpf":"U2FsdGVkX1+TW8pcKDr8SOIefmr+JUGy2SADeSyCl5w="},{"num_cand":"U2FsdGVkX1+yl5DE3xJbvpuQXAbmX92L5zaM+wgQRzE=","cpf":"U2FsdGVkX1/G+XW13AHry2Hl/ky+db7tE+VUe1/j6KQ="},{"num_cand":"U2FsdGVkX1+wVNhHbNqfbHu05CkF7NKSeShZTq8Spdw=","cpf":"U2FsdGVkX1/K6jKDQ7tHGQQpoJXlWD2Icj3Wv6wKT30="},{"num_cand":"U2FsdGVkX19SfrjYDviQHaJo28lqdRynV+1wSFh+O3k=","cpf":"U2FsdGVkX18K9XN3N2ADgbRyiCHUQDqpYtJ/EVXxwA4="},{"num_cand":"U2FsdGVkX1+AxKmdepaSa1ysoG0yg6HeJLfG26yy7yo=","cpf":"U2FsdGVkX1/AGXM9whKoUGAHQmutwzabIHGNR/SDjr8="},{"num_cand":"U2FsdGVkX18Qj5r/wA2xM9J/MIa1MYLRoEGrv7ISPZg=","cpf":"U2FsdGVkX1+UALOIaXxp8mPHO/yb8ZB0pCcjpkpMQz0="},{"num_cand":"U2FsdGVkX1/BWzOneXdOiKZeVgRj5ZjU9acglggXFb8=","cpf":"U2FsdGVkX192qftJiuuVuDa0tzfyhLKVJK83lmf3ypQ="},{"num_cand":"U2FsdGVkX18SQtivUjlavSMMvX7pmsa4aOkwdqq+WPE=","cpf":"U2FsdGVkX1/uUG2oAwe3YOTPN5bPJp+ew4h0rYanXtI="},{"num_cand":"U2FsdGVkX19QK9gxCFMxQusXQw5TjGmxIvd+PCHm4jU=","cpf":"U2FsdGVkX19ZDbB1AGw8osr7pGF8lXPxkDTByJlAxf0="},{"num_cand":"U2FsdGVkX1/lVIWuN3fRUdavZFfNhjcgA1traoqI6qw=","cpf":"U2FsdGVkX1+K/pdiY8ZDl7Gd6svAGOZLKrLfoxycb3A="},{"num_cand":"U2FsdGVkX19W2MZasIMfJ6bXm2I62TPkkxoXdjkPVf4=","cpf":"U2FsdGVkX19HexpRLsPosLXPk6QcIYl7CYjDBfK5lP8="},{"num_cand":"U2FsdGVkX1+X63mpRNuA4FkkfWVP+bfa3w2OYQze9S4=","cpf":"U2FsdGVkX1/VUoXKJrpD2xPwv43BEX9s5vmxOkOOEe8="},{"num_cand":"U2FsdGVkX1+GQk0BkYdgmACCO68hY3h9b02YFOFiQho=","cpf":"U2FsdGVkX189oM6WM17e6DhcqC1l6HXR5tWX4vrosp0="},{"num_cand":"U2FsdGVkX1+L3BKmFxE8d57dje/ROIdD6QjjnP+wk9I=","cpf":"U2FsdGVkX1+mx9dQDPjsKoV4cgE88UvfxKe9LVXVIyQ="},{"num_cand":"U2FsdGVkX1+5OvhfLsoLM4dYGIELfuh93yueNOo7lXk=","cpf":"U2FsdGVkX19iEEHn0ATeyn+5eKl4JTu4JLRJrMaA968="},{"num_cand":"U2FsdGVkX18kLfkjSGicA8ZwAkIW0VwfPqbcWC4u4q4=","cpf":"U2FsdGVkX197IG9LKl032CzcT2W8Q4ZXltmvFXi6Sc0="},{"num_cand":"U2FsdGVkX1/tb/RVC5ckNPZE3u8S4x8YYf5WClRLukg=","cpf":"U2FsdGVkX19P0sj6Pq2LG7bUrhqggJuh9Y85pIDMOUQ="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2203/rec_inv/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
